
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connector.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-registry-connector-demo-connector-normal","docs-api-registry-connector-demo-connector-smooth","docs-api-registry-connector-demo-connector-rounded","docs-api-registry-connector-demo-connector-jumpover","docs-api-registry-connector-demo-connector-wobble"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connector.zh.md?type=demo')
};